import { th } from "date-fns/locale";
import { Edit2, Trash2 } from "lucide-react";

export const getCommodityColumns = (handlers) => {
  const { handleEdit, handleDelete } = handlers;

  return [
    {
      key: "commodity",
      label: "COMMODITY ID",
      render: (v) => v?.commodity || "-"
    },
    {
      key: "htsNumber",
      label: "HTS CODE",
      render: (v) => v?.htsNumber || "-",
      thClass: "px-4 py-4 text-left text-xs font-semibold uppercase tracking-wider whitespace-nowrap"
    },
    {
      key: "commodityDescription",
      label: "DESCRIPTION",
      render: (v) => v?.commodityDescription || "-"
    },
    {
      key: "primaryUOM",
      label: "PRIMARY UOM",
      render: (v) => v?.primaryUOM || "-",
            thClass: "px-4 py-4 text-left text-xs font-semibold uppercase tracking-wider whitespace-nowrap"
    },
    {
      key: "secondaryUOM",
      label: "SECONDARY UOM",
      render: (v) => v?.secondaryUOM || "-",
            thClass: "px-4 py-4 text-left text-xs font-semibold uppercase tracking-wider whitespace-nowrap"
    },
    {
      key: "action",
      label: "ACTION",
      render: (v) => (
        <div className="flex items-center gap-3">
          <button
            onClick={() => handleEdit(v)}
                className="w-6 h-6 rounded flex items-center justify-center transition-all bg-blue-100 text-blue-700 hover:bg-blue-200 "
            title="Edit"
          >
            <Edit2 size={16} />
          </button>

          <button
            onClick={() => handleDelete(v)}
                        className="w-6 h-6 rounded flex items-center justify-center transition-all bg-red-100 text-red-700 hover:bg-red-200 "
            title="Delete"
          >
            <Trash2 size={16} />
          </button>
        </div>
      )
    }
  ];
};